(function () {
  'use strict';

  var initializedBanners = new WeakSet();
  var initializedTimers = new WeakSet();
  var VISITOR_STORAGE_KEY = 'ultimapeak_t0005_two_hour_countdown_started_at_v1';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 400;

  function scheduleStoreMidnightRefresh(banner) {
    if (!banner || initializedBanners.has(banner)) return;
    initializedBanners.add(banner);

    if (banner.dataset.campaignDesign !== 'true') return;

    var storeSecondsToday = Number(banner.dataset.storeSecondsToday);
    if (!Number.isFinite(storeSecondsToday)) return;

    var secondsInDay = 24 * 60 * 60;
    var secondsUntilMidnight = secondsInDay - storeSecondsToday;
    var delay = Math.max(2, secondsUntilMidnight + 2) * 1000;

    window.setTimeout(function () {
      window.location.reload();
    }, delay);
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function normalizeStoreOffset(offset) {
    if (!offset) return '';
    var match = String(offset).match(/^([+-])(\d{2})(\d{2})$/);
    if (!match) return offset;
    return match[1] + match[2] + ':' + match[3];
  }

  function parseCountdownEnd(rawValue, storeOffset) {
    if (!rawValue) return NaN;

    var direct = Date.parse(rawValue);

    // If the merchant entered a timezone explicitly, keep it as-is.
    if (/([zZ]|[+-]\d{2}:?\d{2}|\b(?:GMT|UTC)\b)/.test(rawValue)) {
      return direct;
    }

    // The Theme Editor value is documented as store time. Add the current
    // Shopify store offset so visitors in other timezones see the same timer.
    var normalizedOffset = normalizeStoreOffset(storeOffset);
    var withOffset = Date.parse(rawValue + ' GMT' + normalizedOffset.replace(':', ''));

    return Number.isNaN(withOffset) ? direct : withOffset;
  }

  function getCookie(name) {
    var prefix = encodeURIComponent(name) + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var item = parts[i].trim();
      if (item.indexOf(prefix) === 0) {
        return decodeURIComponent(item.slice(prefix.length));
      }
    }
    return null;
  }

  function setCookie(name, value) {
    try {
      document.cookie =
        encodeURIComponent(name) +
        '=' +
        encodeURIComponent(value) +
        '; path=/; max-age=' +
        COOKIE_MAX_AGE +
        '; samesite=lax';
    } catch (error) {
      // The countdown still works for the current page if storage is blocked.
    }
  }

  function readVisitorStart() {
    var value = null;

    try {
      value = window.localStorage.getItem(VISITOR_STORAGE_KEY);
    } catch (error) {
      value = null;
    }

    if (!value) value = getCookie(VISITOR_STORAGE_KEY);

    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function writeVisitorStart(timestamp) {
    var value = String(timestamp);

    try {
      window.localStorage.setItem(VISITOR_STORAGE_KEY, value);
    } catch (error) {
      // Cookie fallback below.
    }

    setCookie(VISITOR_STORAGE_KEY, value);
  }

  function getTimerParts(timer) {
    return {
      hours: timer.querySelector('[data-countdown-hours]'),
      minutes: timer.querySelector('[data-countdown-minutes]'),
      seconds: timer.querySelector('[data-countdown-seconds]')
    };
  }

  function paintTimer(parts, remainingMs, roundUp) {
    var totalSeconds = roundUp
      ? Math.ceil(Math.max(0, remainingMs) / 1000)
      : Math.floor(Math.max(0, remainingMs) / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    parts.hours.textContent = pad(hours);
    parts.minutes.textContent = pad(minutes);
    parts.seconds.textContent = pad(seconds);
  }

  function hideTimer(timer) {
    timer.hidden = true;
    timer.setAttribute('aria-hidden', 'true');
  }

  function initVisitorCountdown(timer) {
    var parts = getTimerParts(timer);
    if (!parts.hours || !parts.minutes || !parts.seconds) return;

    var durationSeconds = Number(timer.dataset.countdownDurationSeconds || 7200);
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) durationSeconds = 7200;

    var startTime = readVisitorStart();
    if (!startTime) {
      startTime = Date.now();
      writeVisitorStart(startTime);
    }

    var endTime = startTime + durationSeconds * 1000;
    var intervalId = null;

    function update() {
      var remaining = endTime - Date.now();

      if (remaining <= 0) {
        paintTimer(parts, 0, true);
        hideTimer(timer);
        if (intervalId) window.clearInterval(intervalId);
        return;
      }

      // Ceil ensures a brand-new visitor sees exactly 02:00:00 first,
      // rather than losing a second during initial render.
      paintTimer(parts, remaining, true);
    }

    update();
    if (!timer.hidden) intervalId = window.setInterval(update, 1000);
  }

  function initFixedCountdown(timer, banner) {
    var endTime = parseCountdownEnd(
      timer.dataset.countdownEnd,
      banner ? banner.dataset.storeTimezoneOffset : ''
    );

    if (!Number.isFinite(endTime)) return;

    var parts = getTimerParts(timer);
    if (!parts.hours || !parts.minutes || !parts.seconds) return;

    var intervalId = null;

    function update() {
      var remaining = Math.max(0, endTime - Date.now());
      paintTimer(parts, remaining, false);

      if (remaining <= 0 && intervalId) {
        window.clearInterval(intervalId);
      }
    }

    update();
    intervalId = window.setInterval(update, 1000);
  }

  function initCountdown(timer, banner) {
    if (!timer || initializedTimers.has(timer)) return;
    initializedTimers.add(timer);

    if (timer.dataset.countdownMode === 'visitor-2h') {
      initVisitorCountdown(timer);
      return;
    }

    initFixedCountdown(timer, banner);
  }

  function initSaleBanners(root) {
    var scope = root || document;
    var banners = scope.querySelectorAll
      ? scope.querySelectorAll('[data-pdp-sale-banner-v3]')
      : [];

    banners.forEach(function (banner) {
      scheduleStoreMidnightRefresh(banner);

      var timer = banner.querySelector('[data-pdp-sale-countdown]');
      if (timer) initCountdown(timer, banner);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaleBanners(document);
    });
  } else {
    initSaleBanners(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaleBanners(event.target);
  });
})();
